  (function () {
    var root = (document.currentScript && document.currentScript.closest && document.currentScript.closest('.dw-section')) ||
               document.querySelector('.dw-section');
    if (!root) return;
    if (root._dwInited) return;
    root._dwInited = true;

    var navList = root.querySelector('.dw-nav-list');
    var navItems = Array.prototype.slice.call(root.querySelectorAll('.dw-nav-item'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.dw-panel'));

    function findNavById(blockId) {
      return navItems.find(function (it) { return it.getAttribute('data-block-id') === blockId; });
    }

    navItems.forEach(function (item, idx) {
      item.setAttribute('tabindex', idx === 0 ? '0' : '-1');
    });

    function setActiveById(blockId, focusNavItem) {
      if (!blockId) return;
      var navMatch = findNavById(blockId);
      if (!navMatch) return;

      navItems.forEach(function (item) {
        var id = item.getAttribute('data-block-id');
        var isActive = id === blockId;
        if (isActive) {
          item.classList.add('active');
          item.setAttribute('aria-current', 'true');
          item.setAttribute('tabindex', '0');
          if (focusNavItem) try { item.focus(); } catch (e) {}
          try { item.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
        } else {
          item.classList.remove('active');
          item.removeAttribute('aria-current');
          item.setAttribute('tabindex', '-1');
        }
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-block-id') === blockId;
        if (isActive) {
          panel.classList.add('active');
          panel.removeAttribute('aria-hidden');
          panel.setAttribute('tabindex', '0');
          try {
            var title = panel.querySelector('.dw-panel-title');
          } catch (e) {}
        } else {
          panel.classList.remove('active');
          panel.setAttribute('aria-hidden', 'true');
          panel.setAttribute('tabindex', '-1');
        }
      });

      try {
        history.replaceState && history.replaceState(null, '', '#dw-' + encodeURIComponent(blockId));
      } catch (e) {}
    }

    if (!navItems || navItems.length === 0) return;

    var rawHash = (location.hash || '').replace(/^#/, '');
    var startId;
    if (rawHash) {
      try {
        rawHash = decodeURIComponent(rawHash);
      } catch (e) {}
      startId = rawHash.replace(/^dw-/, '');
      if (!findNavById(startId)) startId = navItems[0].getAttribute('data-block-id');
    } else {
      startId = navItems[0].getAttribute('data-block-id');
    }

    var isMobileInit = window.matchMedia && window.matchMedia('(max-width: 1000px)').matches;
    if (!isMobileInit) {
      setActiveById(startId, false);
    } else {
      navItems.forEach(function(item, idx){
        item.classList.remove('active');
        item.removeAttribute('aria-current');
        item.setAttribute('tabindex', idx === 0 ? '0' : '-1');
      });
      panels.forEach(function(panel){
        panel.classList.remove('active');
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('tabindex', '-1');
      });
    }

    navList.addEventListener('click', function(e){
      var el = e.target;
      var item = el.closest && el.closest('.dw-nav-item');
      if (!item) return;
      var id = item.getAttribute('data-block-id');
      setActiveById(id, true);
    });

    navItems.forEach(function (item) {
      item.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key === 'Enter' || key === ' ') {
          e.preventDefault();
          var id = item.getAttribute('data-block-id');
          setActiveById(id, true);
          return;
        }

        var li = item.closest('li');
        var firstLi = item.parentElement.firstElementChild;
        var lastLi = item.parentElement.lastElementChild;
        var nextLi = li && li.nextElementSibling;
        var prevLi = li && li.previousElementSibling;

        var firstItem = firstLi && firstLi.querySelector('.dw-nav-item');
        var lastItem = lastLi && lastLi.querySelector('.dw-nav-item');
        var next = nextLi ? nextLi.querySelector('.dw-nav-item') : firstItem;
        var prev = prevLi ? prevLi.querySelector('.dw-nav-item') : lastItem;

        if (key === 'ArrowDown' || key === 'ArrowRight') {
          e.preventDefault();
          item.setAttribute('tabindex', '-1');
          if (next) {
            next.setAttribute('tabindex', '0');
            next.focus();
          }
        } else if (key === 'ArrowUp' || key === 'ArrowLeft') {
          e.preventDefault();
          item.setAttribute('tabindex', '-1');
          if (prev) {
            prev.setAttribute('tabindex', '0');
            prev.focus();
          }
        } else if (key === 'Home') {
          e.preventDefault();
          item.setAttribute('tabindex', '-1');
          if (firstItem) {
            firstItem.setAttribute('tabindex', '0');
            firstItem.focus();
          }
        } else if (key === 'End') {
          e.preventDefault();
          item.setAttribute('tabindex', '-1');
          if (lastItem) {
            lastItem.setAttribute('tabindex', '0');
            lastItem.focus();
          }
        }
      });
    });

    window.addEventListener('hashchange', function () {
      var raw = (location.hash || '').replace(/^#/, '');
      if (!raw) return;
      try { raw = decodeURIComponent(raw); } catch (e) {}
      var h = raw.replace(/^dw-/, '');
      if (h) setActiveById(h, true);
    });

  })();